var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "md:absolute left-full ml-5" }, [
    _c(
      "div",
      {
        staticClass:
          "\n      circle-full\n      w-6\n      h-6\n      bg-velux-grey-900\n      rounded-full\n      text-velux-white text-sm\n      flex\n      items-center\n      justify-center\n      cursor-pointer\n    ",
        on: {
          click: function($event) {
            $event.stopPropagation()
            _vm.isOpen = true
            _vm.trackTooltip()
          }
        }
      },
      [_c("i", { staticClass: "fas fa-info" })]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "\n      fixed\n      left-0\n      right-0\n      top-0\n      bottom-0\n      w-full\n      h-full\n      flex\n      items-center\n      justify-center\n    ",
        class: { hidden: !_vm.isOpen },
        staticStyle: { "z-index": "1002" }
      },
      [
        _c("div", {
          staticClass:
            "absolute w-full h-full bg-opacity-50 bg-velux-grey-900 z-1",
          on: {
            click: function($event) {
              $event.stopPropagation()
              _vm.isOpen = false
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "\n        max-h-screen\n        overflow-auto\n        bg-velux-white\n        max-w-2xl\n        px-6\n        md:px-24 \n        pt-16 pb-8\n        relative\n        z-10\n      ",
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "\n          text-xl\n          md:text-2xl\n          text-velux-grey-800\n          opacity-80\n          cursor-pointer\n          w-8\n          h-8\n          flex\n          items-center\n          justify-center\n          absolute\n          right-4\n          md:right-8\n          top-3\n          md:top-4\n        ",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    _vm.isOpen = false
                  }
                }
              },
              [
                _c("i", {
                  staticClass: "far fa-times sticky top-4 flex-shrink-0"
                })
              ]
            ),
            _vm._v(" "),
            _c("h2", {
              domProps: { innerHTML: _vm._s(_vm.settings.TooltipTitle) }
            }),
            _vm._v(" "),
            _c("p", {
              domProps: { innerHTML: _vm._s(_vm.settings.TooltipBody) }
            })
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }